var map = {
	"./Beginner-1.gif": "0fa1",
	"./Beginner-2.gif": "c33f",
	"./Beginner-3.gif": "0d80",
	"./Beginner-4.gif": "04a7",
	"./Beginner-5.gif": "9f6e",
	"./Beginner-6.gif": "0d75",
	"./Billionaire-1.gif": "5f68",
	"./Billionaire-2.gif": "d5ab",
	"./Billionaire-3.gif": "0c87",
	"./Billionaire-4.gif": "17b2",
	"./Billionaire-5.gif": "b36e",
	"./Billionaire-6.gif": "fc5a",
	"./Boss-1.gif": "7114",
	"./Boss-2.gif": "ddad",
	"./Boss-3.gif": "d062",
	"./Boss-4.gif": "1e71",
	"./Boss-5.gif": "62bc",
	"./Boss-6.gif": "1617",
	"./Master-1.gif": "0e65",
	"./Master-2.gif": "d6e7",
	"./Master-3.gif": "ff79",
	"./Master-4.gif": "4d10",
	"./Master-5.gif": "1635",
	"./Master-6.gif": "66e7",
	"./Millionaire-1.gif": "2541",
	"./Millionaire-2.gif": "bd08",
	"./Millionaire-3.gif": "8284",
	"./Millionaire-4.gif": "e7fe",
	"./Millionaire-5.gif": "fa45",
	"./Millionaire-6.gif": "7a91",
	"./Professional-1.gif": "560c",
	"./Professional-2.gif": "d424f",
	"./Professional-3.gif": "59cb",
	"./Professional-4.gif": "6b6c",
	"./Professional-5.gif": "a23c",
	"./Professional-6.gif": "b741",
	"./Rookie-1.gif": "4c60",
	"./Rookie-2.gif": "3d69",
	"./Rookie-3.gif": "39e2",
	"./Rookie-4.gif": "b3fd",
	"./Rookie-5.gif": "7a29",
	"./Rookie-6.gif": "86b7",
	"./Trillionaire-1.gif": "a076",
	"./Trillionaire-2.gif": "ae26",
	"./Trillionaire-3.gif": "96f3",
	"./Trillionaire-4.gif": "dce2",
	"./Trillionaire-5.gif": "9094",
	"./Trillionaire-6.gif": "0913"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "99b4";